export const TRANSITION_TIME_MS = 150;
